export default __webpack_public_path__ + "static/media/two_four_hour_hand.26a9397e.svg";